import type { Translate } from '../../../shared/source/internationalization/translation';

export type OnboardingLabelsStoreState = {
    readonly companyDescriptionLabel: string;
    readonly companyPrioritiesLabel: string;
    readonly companyPrioritiesSubTitle: string;
    readonly companyPrioritiesTitle: string;
    readonly companyProfileIntroductionDescriptionLabel: string;
    readonly companyProfileIntroductionLabel: string;
    readonly companyProfileLabel: string;
    readonly continueLabel: string;
    readonly descriptionLabel: string;
    readonly employeeProfileLabel: string;
    readonly finishOnboardingLabel: string;
    readonly inviteYourTeamLabel: string;
    readonly jobTitleLabel: string;
    readonly jobTitlePlaceholderLabel: string;
    readonly provideYourDataHeadlineLabel: string;
    readonly provideYourDataSubHeadlineLabel: string;
    readonly reviewSkillMosaicLabel: string;
    readonly setupCobrainerLabel: string;
    readonly skillMosaicLabel: string;
};

export const getTranslatedOnboardingLabels = (translate: Translate): OnboardingLabelsStoreState => {
    return {
        companyDescriptionLabel: translate('pages.company-onboarding.company-description'),
        companyPrioritiesLabel: translate('pages.company-onboarding.company-priorities'),
        companyPrioritiesSubTitle: translate('pages.company-onboarding.company-priorities-subtitle'),
        companyPrioritiesTitle: translate('pages.company-onboarding.company-priorities-title'),
        companyProfileIntroductionDescriptionLabel: translate('company-onboarding.profile-introduction-description'),
        companyProfileIntroductionLabel: translate('company-onboarding.profile-introduction'),
        companyProfileLabel: translate('pages.company-onboarding.company-profile'),
        continueLabel: translate('common.continue'),
        descriptionLabel: translate('common.description'),
        employeeProfileLabel: translate('pages.company-onboarding.employee-profile'),
        finishOnboardingLabel: translate('common.finish'),
        inviteYourTeamLabel: translate('pages.company-onboarding.invite-your-team'),
        jobTitleLabel: translate('company-onboarding.provide-your-data.job-title'),
        jobTitlePlaceholderLabel: translate('company-onboarding.provide-your-data.job-title-placeholder'),
        provideYourDataHeadlineLabel: translate('company-onboarding.provide-your-data.headline'),
        provideYourDataSubHeadlineLabel: translate('company-onboarding.provide-your-data.subheadline'),
        reviewSkillMosaicLabel: translate('pages.company-onboarding.review-skill-mosaic'),
        setupCobrainerLabel: translate('pages.company-onboarding.setup-cobrainer'),
        skillMosaicLabel: translate('pages.company-onboarding.skill-mosaic'),
    };
};
